var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "empty-block",
    class: [("empty-block_" + (_vm.type))]
  }, [_c('div', {
    staticClass: "empty-block__wrapper"
  }, [_c('p', {
    staticClass: "empty-block__title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "empty-block__description"
  }, [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "empty-block__row"
  }, [_c('Button', {
    attrs: {
      "theme": "white",
      "icon": "add"
    },
    on: {
      "click": _vm.goToPage
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getButtonTitle) + "\n    ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }